'use client';

import { useSanitizedHtml } from '../../../utils/sanitize';
import type { QuestionType } from '../Question.types';
import { QuestionImage } from './QuestionImage';

import styles from './QuestionStatement.module.scss';

type QuestionStatementProps = {
  question: QuestionType;
};

/** What the question asks: its subject, its statement, its caption and its image. */
function QuestionStatement({ question }: QuestionStatementProps) {
  const textHtml = useSanitizedHtml(question.text);

  return (
    <div className={styles['main']}>
      {question.subject && (
        <span className={styles['subject']}>{question.subject}</span>
      )}
      <div dangerouslySetInnerHTML={textHtml} />
      {question.caption && (
        <span className={styles['caption']}>{question.caption}</span>
      )}
      {question.imageUrl && <QuestionImage src={question.imageUrl} />}
    </div>
  );
}

export { QuestionStatement };
